export default __webpack_public_path__ + "static/media/Gesture_white_Hit.13e9ad47.svg";